import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';

/**
 * The modals one component has open. NgbModal never closes a modal on navigation, so an opener dismisses
 * its own in `ngOnDestroy` — otherwise a card or dialog outlives the page, and its callbacks run against a
 * destroyed component.
 */
export class OpenModals {

  private readonly refs = new Set<NgbModalRef>();

  /** Tracks a modal until it closes either way. */
  public track(ref: NgbModalRef): NgbModalRef {
    this.refs.add(ref);
    const forget = () => this.refs.delete(ref);
    ref.result.then(forget, forget);
    return ref;
  }

  public dismissAll(): void {
    Array.from(this.refs).forEach(ref => ref.dismiss());
    this.refs.clear();
  }
}

/** Emits once when no modal is open — at once if none is. Keeps a deep-linked card and the splash from stacking. */
export function afterModalsClose(modalService: NgbModal, until$: Observable<void>): Observable<void> {
  if (!modalService.hasOpenModals()) {
    return of(undefined);
  }
  return modalService.activeInstances.pipe(
    filter(instances => instances.length === 0),
    take(1),
    map(() => undefined),
    takeUntil(until$)
  );
}
